import React from 'react';

export default function ArrowRight() {
  return <svg width="16" height="12" viewBox="0 0 15.5 11.5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.75 5.75H14.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.75 10.75L14.75 5.75L9.75 0.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
}
